import { getCompanyHubEditorRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { HubEditorRoute } from './HubEditorRoute.tsx';

export const CompanyHubEditorRoute = getCompanyHubEditorRoute(HubEditorRoute);
